import Secretary from './Secretary';

export default Secretary;
